import { ComponentPropsWithoutRef, forwardRef } from "react";

import classNames from "classnames";

import styles from "./StyledNativeInput.module.scss";

/**
 * A shared text input element backed by form SCSS.
 */
export type StyledNativeInputProps = ComponentPropsWithoutRef<"input">;

export const StyledNativeInput = forwardRef<HTMLInputElement, StyledNativeInputProps>(function StyledNativeInput(
  { className, ...props },
  ref,
) {
  return <input {...props} className={classNames(styles.NativeInput, className)} ref={ref} />;
});
